async function droplitSingleRemoveBackground(drop, trigger) {
  const endpoint = 'https://droplit-background-removal.brian-1b8.workers.dev/remove-background';
  const dialog = document.createElement('dialog');
  dialog.setAttribute('aria-label', 'Remove background');
  dialog.style.cssText = 'width:min(360px,calc(100vw - 32px));max-height:85dvh;box-sizing:border-box;padding:24px;border:0;border-radius:20px;background:white;color:#111;box-shadow:0 12px 70px #0005;font:16px/1.5 system-ui;text-align:center;';
  const title = document.createElement('h2');
  title.textContent = 'Remove background';
  title.style.cssText = 'font:700 22px/1.3 system-ui;margin:0 0 12px;';
  const status = document.createElement('p');
  status.setAttribute('role', 'status');
  status.textContent = 'Preparing your image…';
  const widget = document.createElement('div');
  widget.style.cssText = 'display:flex;justify-content:center;min-width:0;';
  const cancel = document.createElement('button');
  cancel.type = 'button';
  cancel.textContent = 'Cancel';
  cancel.style.cssText = 'margin-top:18px;min-height:44px;padding:10px 24px;border:1px solid #ccc;border-radius:999px;background:#fff;color:#111;font:600 16px system-ui;cursor:pointer;';
  dialog.append(title, status, widget, cancel);
  document.body.append(dialog);
  dialog.showModal();
  const controller = new AbortController();
  let widgetId;
  const abort = () => controller.abort();
  cancel.addEventListener('click', abort);
  dialog.addEventListener('cancel', event => { event.preventDefault(); abort(); });
  const overallTimeout = setTimeout(abort, 150000);
  const wait = promise => new Promise((resolve, reject) => {
    const stop = () => reject(new DOMException('Cancelled', 'AbortError'));
    if (controller.signal.aborted) { stop(); return; }
    controller.signal.addEventListener('abort', stop, { once: true });
    promise.then(resolve, reject).finally(() => controller.signal.removeEventListener('abort', stop));
  });
  try {
    const source = drop.preview;
    if (!source) throw new Error('Please select an image first.');
    const image = new Image();
    image.crossOrigin = 'anonymous';
    await wait(new Promise((resolve, reject) => {
      const timer = setTimeout(() => reject(new Error('The image took too long to load. Please try again.')), 20000);
      image.onload = () => { clearTimeout(timer); resolve(); };
      image.onerror = () => { clearTimeout(timer); reject(new Error('This image could not be read. Try uploading a PNG or JPG copy.')); };
      image.src = source;
    }));
    const ratio = Math.min(1, 1200 / Math.max(image.naturalWidth, image.naturalHeight));
    const canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.round(image.naturalWidth * ratio));
    canvas.height = Math.max(1, Math.round(image.naturalHeight * ratio));
    let input;
    try {
      const context = canvas.getContext('2d');
      if (!context) throw new Error('Image preparation is unavailable. Please try again.');
      context.drawImage(image, 0, 0, canvas.width, canvas.height);
      input = await wait(new Promise((resolve, reject) => canvas.toBlob(
        blob => blob ? resolve(blob) : reject(new Error('Could not prepare this image.')),
        'image/png'
      )));
    } catch (error) {
      if (error.name === 'SecurityError') throw new Error('This library image cannot be processed by its image host. Upload a PNG or JPG copy instead.');
      throw error;
    } finally { canvas.width = 1; canvas.height = 1; }
    if (input.size > 10 * 1024 * 1024) throw new Error('Please choose a smaller image.');
    status.textContent = 'Verifying… Complete the check below if asked.';
    if (!window.turnstile?.render) {
      if (!window.__dlTurnstileLoad) {
        window.__dlTurnstileLoad = new Promise((resolve, reject) => {
          const script = document.createElement('script');
          const timer = setTimeout(() => { script.remove(); reject(new Error('Verification could not load. Please try again.')); }, 20000);
          script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
          script.async = true;
          script.onload = () => { clearTimeout(timer); resolve(); };
          script.onerror = () => { clearTimeout(timer); script.remove(); reject(new Error('Verification could not load. Please try again.')); };
          document.head.append(script);
        }).catch(error => { window.__dlTurnstileLoad = null; throw error; });
      }
      await wait(window.__dlTurnstileLoad);
    }
    const token = await wait(new Promise((resolve, reject) => {
      widgetId = window.turnstile.render(widget, {
        sitekey: '0x4AAAAAAE-QE7XH9b-Nh_k8',
        action: 'remove_background',
        theme: 'light',
        size: 'flexible',
        callback: resolve,
        'error-callback': () => { reject(new Error('Verification failed. Please try again.')); return true; },
        'expired-callback': () => reject(new Error('Verification expired. Please try again.')),
        'timeout-callback': () => reject(new Error('Verification timed out. Please try again.'))
      });
    }));
    widget.hidden = true;
    status.textContent = 'Removing the background… Your original image is safe.';
    const response = await fetch(endpoint, {
      method: 'POST', credentials: 'omit', signal: controller.signal,
      headers: { 'Content-Type': 'image/png', 'X-Turnstile-Token': token },
      body: input
    });
    if (!response.ok) {
      const detail = await response.json().catch(() => ({}));
      throw new Error(detail.error || 'Background removal is unavailable. Please try again.');
    }
    if (!(response.headers.get('Content-Type') || '').startsWith('image/png')) throw new Error('An unexpected response was received. Please try again.');
    const output = await response.blob();
    if (!output.size || output.size > 25 * 1024 * 1024) throw new Error('The processed image could not be used. Please try a smaller image.');
    if (controller.signal.aborted) throw new DOMException('Cancelled', 'AbortError');
    return new File([output], 'drop-background-removed.png', { type: 'image/png', lastModified: Date.now() });
  } finally {
    clearTimeout(overallTimeout);
    if (widgetId !== undefined) { try { window.turnstile.remove(widgetId); } catch (_) {} }
    dialog.close();
    dialog.remove();
    trigger?.focus({ preventScroll: true });
  }
}
window.droplitSingleEditor = function(root, getSelected, changed) {
  const $ = s => root.querySelector(s), words=$('[data-standalone-strings]').dataset;
  let original=null, bitmap=null, token=0, timer, active=false, backgroundBusy=false, currentURL='';
  const edges=[...root.querySelectorAll('[data-crop-edge]')], radius=$('[data-corner-radius]');
  const status=m=>{$('[data-edit-status]').textContent=m;};
  function controls(disabled){root.querySelectorAll('[data-editor] input,[data-editor] button').forEach(el=>el.disabled=disabled);}
  function valuesReset(){for(const e of edges){e.value=0;root.querySelector(`[data-crop-value="${e.dataset.cropEdge}"]`).textContent='0%';}radius.value=0;$('[data-radius-value]').textContent='0%';}
  function preview(mode){$('[data-hat-stage]').hidden=mode!=='hat';$('[data-hat-note]').hidden=mode!=='hat';$('[data-drop-stage]').hidden=mode!=='drop';root.querySelectorAll('[data-preview-mode]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.previewMode===mode)));}
  root.querySelectorAll('[data-preview-mode]').forEach(b=>b.addEventListener('click',()=>preview(b.dataset.previewMode)));
  async function render(){
    const item=getSelected(),version=++token;
    if(!bitmap||item?.source!=='custom')return;
    active=true;status(words.editing);
    const v=Object.fromEntries(edges.map(e=>[e.dataset.cropEdge,Number(e.value)/100]));
    const x=Math.round(bitmap.width*v.left),y=Math.round(bitmap.height*v.top);
    const w=Math.max(1,Math.round(bitmap.width*(1-v.left-v.right))),h=Math.max(1,Math.round(bitmap.height*(1-v.top-v.bottom)));
    const canvas=document.createElement('canvas');canvas.width=w;canvas.height=h;
    try{
      const ctx=canvas.getContext('2d');ctx.beginPath();ctx.roundRect(0,0,w,h,Math.min(w,h)*Number(radius.value)/100);ctx.clip();ctx.drawImage(bitmap,x,y,w,h,0,0,w,h);
      const blob=await new Promise(resolve=>canvas.toBlob(resolve,'image/png'));
      if(!blob)throw new Error();if(version!==token||item!==getSelected())return;
      const url=URL.createObjectURL(blob);if(currentURL)URL.revokeObjectURL(currentURL);currentURL=url;
      item.file=new File([blob],item.title+'.png',{type:'image/png'});item.preview=url;changed();status(words.edited);
    }catch{if(version===token)status(words.editError);}
    finally{canvas.width=canvas.height=1;if(version===token)active=false;}
  }
  async function load(file,version){
    const image=await createImageBitmap(file);
    if(version!==token){image.close();return false;}
    bitmap?.close();bitmap=image;return true;
  }
  for(const e of edges)e.addEventListener('input',()=>{
    const opposite={left:'right',right:'left',top:'bottom',bottom:'top'}[e.dataset.cropEdge];
    const other=edges.find(x=>x.dataset.cropEdge===opposite);e.value=Math.min(Number(e.value),90-Number(other.value));
    root.querySelector(`[data-crop-value="${e.dataset.cropEdge}"]`).textContent=e.value+'%';schedule();
  });
  radius.addEventListener('input',()=>{$('[data-radius-value]').textContent=radius.value+'%';schedule();});
  function schedule(){clearTimeout(timer);active=true;++token;timer=setTimeout(render,120);}
  const dialog=$('[data-crop-dialog]'),wrap=$('[data-crop-wrap]'),box=$('[data-crop-box]'),cropCanvas=$('[data-crop-canvas]'),round=$('[data-dialog-round]');
  let bounds={l:0,t:0,r:1,b:1},drag=null,cropItem=null;
  function drawBox(){box.style.left=bounds.l*100+'%';box.style.top=bounds.t*100+'%';box.style.width=(bounds.r-bounds.l)*100+'%';box.style.height=(bounds.b-bounds.t)*100+'%';const radiusPx=Math.min(wrap.clientWidth*(bounds.r-bounds.l),wrap.clientHeight*(bounds.b-bounds.t))*Number(round.value)/100;box.style.borderRadius=radiusPx+'px';$('[data-dialog-round-value]').textContent=round.value+'%';}
  function closeCrop(){dialog.close();drag=null;$('[data-open-crop]').focus();}
  $('[data-open-crop]').addEventListener('click',()=>{
    if(active||backgroundBusy||!bitmap||getSelected()?.source!=='custom')return;
    cropItem=getSelected();const values=Object.fromEntries(edges.map(e=>[e.dataset.cropEdge,Number(e.value)/100]));bounds={l:values.left,t:values.top,r:1-values.right,b:1-values.bottom};round.value=radius.value;
    const scale=Math.min(1,1200/Math.max(bitmap.width,bitmap.height));cropCanvas.width=Math.max(1,Math.round(bitmap.width*scale));cropCanvas.height=Math.max(1,Math.round(bitmap.height*scale));cropCanvas.getContext('2d').drawImage(bitmap,0,0,cropCanvas.width,cropCanvas.height);
    wrap.style.width=Math.min(560,window.innerWidth-88,window.innerHeight*.5*bitmap.width/bitmap.height)+'px';dialog.showModal();drawBox();
  });
  round.addEventListener('input',drawBox);
  $('[data-crop-cancel]').addEventListener('click',closeCrop);
  dialog.addEventListener('cancel',e=>{e.preventDefault();closeCrop();});
  function move(dx,dy,handle,start){
    bounds={...start};
    if(!handle){const w=start.r-start.l,h=start.b-start.t;bounds.l=Math.max(0,Math.min(1-w,start.l+dx));bounds.t=Math.max(0,Math.min(1-h,start.t+dy));bounds.r=bounds.l+w;bounds.b=bounds.t+h;}
    else{if(handle.includes('l'))bounds.l=Math.max(0,Math.min(start.r-.05,start.l+dx));else bounds.r=Math.min(1,Math.max(start.l+.05,start.r+dx));if(handle.includes('t'))bounds.t=Math.max(0,Math.min(start.b-.05,start.t+dy));else bounds.b=Math.min(1,Math.max(start.t+.05,start.b+dy));}drawBox();
  }
  box.addEventListener('pointerdown',e=>{e.preventDefault();drag={id:e.pointerId,x:e.clientX,y:e.clientY,handle:e.target.closest('[data-crop-handle]')?.dataset.cropHandle,bounds:{...bounds}};box.setPointerCapture?.(e.pointerId);});
  box.addEventListener('pointermove',e=>{if(!drag||drag.id!==e.pointerId)return;const rect=wrap.getBoundingClientRect();if(!rect.width||!rect.height)return;move((e.clientX-drag.x)/rect.width,(e.clientY-drag.y)/rect.height,drag.handle,drag.bounds);});
  for(const name of ['pointerup','pointercancel','lostpointercapture'])box.addEventListener(name,()=>{drag=null;});
  box.addEventListener('keydown',e=>{const delta={ArrowLeft:[-.01,0],ArrowRight:[.01,0],ArrowUp:[0,-.01],ArrowDown:[0,.01]}[e.key];if(!delta)return;e.preventDefault();move(...delta,e.target.dataset.cropHandle,{...bounds});});
  $('[data-crop-apply]').addEventListener('click',async()=>{
    if(cropItem!==getSelected()||getSelected()?.source!=='custom'){closeCrop();return;}
    for(const e of edges){const key=e.dataset.cropEdge;e.value=String((key==='left'?bounds.l:key==='top'?bounds.t:key==='right'?1-bounds.r:1-bounds.b)*100);root.querySelector(`[data-crop-value="${key}"]`).textContent=Math.round(Number(e.value))+'%';}
    radius.value=round.value;$('[data-radius-value]').textContent=radius.value+'%';closeCrop();await render();
  });
  $('[data-reset-edit]').addEventListener('click',async()=>{
    if(!original||getSelected()?.source!=='custom')return;
    const version=++token;clearTimeout(timer);active=true;controls(true);valuesReset();
    try{if(await load(original,version))await render();}catch{if(version===token)status(words.editError);}
    finally{active=false;controls(false);}
  });
  $('[data-remove-background]').addEventListener('click',async e=>{
    const item=getSelected();if(item?.source!=='custom'||active||backgroundBusy)return;
    const version=++token;backgroundBusy=true;controls(true);
    try{
      const result=await droplitSingleRemoveBackground(item,e.currentTarget);
      if(version!==token||item!==getSelected())return;
      if(await load(result,version)){valuesReset();await render();}
    }catch(error){if(item===getSelected())status(error.name==='AbortError'?'':words.editError);}
    finally{backgroundBusy=false;controls(false);}
  });
  return {
    get busy(){return active||backgroundBusy;},
    async select(){
      const version=++token;clearTimeout(timer);active=false;bitmap?.close();bitmap=null;
      if(currentURL){URL.revokeObjectURL(currentURL);currentURL='';}
      const item=getSelected(),custom=item?.source==='custom';original=custom?item.file:null;
      $('[data-editor]').hidden=!custom;$('[data-art-locked]').hidden=!item||custom;valuesReset();status('');
      if(!custom)return;active=true;controls(true);
      try{await load(original,version);}catch{if(version===token)status(words.editError);}
      finally{if(version===token){active=false;controls(false);}}
    }
  };
};
